import { Routes } from '@angular/router';
import { Paiement } from './paiement/paiement';
import { PageNotFound } from './page-not-found/page-not-found';

export const routes: Routes = [
    {path:'paiement/:token',component:Paiement},
    {path:'**',component:PageNotFound}
];
